module.exports = __webpack_public_path__ + "static/media/review.1c7b7903.svg";